import { defineStore } from 'pinia';
import { ref } from 'vue';
import { apiGet, apiPost, ApiError } from '@/api/client';
import type { MeUser } from '@/api/types';

export const useAuthStore = defineStore('auth', () => {
  const user = ref<MeUser | null>(null);
  const loading = ref(true);
  const needsLogin = ref(false);

  async function fetchMe(): Promise<void> {
    loading.value = true;
    try {
      user.value = await apiGet<MeUser>('/api/me');
      needsLogin.value = false;
    } catch (err) {
      if (err instanceof ApiError && err.status === 401) {
        needsLogin.value = true;
        user.value = null;
      } else {
        throw err;
      }
    } finally {
      loading.value = false;
    }
  }

  function login() { window.location.href = '/auth/login'; }

  async function logout(): Promise<void> {
    try {
      const resp = await apiPost<{ logoutUrl?: string; ok?: boolean }>('/auth/logout', {});
      window.location.href = resp.logoutUrl ?? '/';
    } catch {
      window.location.href = '/';
    }
  }

  return { user, loading, needsLogin, fetchMe, login, logout };
});
